// extracted by mini-css-extract-plugin
export default {"Modal":"ESw4g_qu","opened":"RuLiugLP","content":"NxhSG1qz","container":"X1Q7Li6i","title":"b_IjUd1A","text":"L169J8CB","close":"MDpcmzhw","closeIcon":"nRfmkIjU","onSide":"PSpGfBEh"};
    if(module.hot) {
      // 1764331285183
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  